import {
  REQUEST_STATUS_CONFIG,
  type VerificationRequestStatus,
} from '@/features/verifications/types/verification.types';

const PART_ORDER: VerificationRequestStatus[] = [
  'CONFIRMED',
  'PENDING',
  'DECLINED',
  'UNABLE_TO_VERIFY',
  'DRAFT',
];

function contactsLabel(total: number): string {
  return `${total} reference contact${total === 1 ? '' : 's'}`;
}

function countOf(statuses: VerificationRequestStatus[], wanted: VerificationRequestStatus): number {
  return statuses.filter((status) => status === wanted).length;
}

function detail(statuses: VerificationRequestStatus[]): string {
  const [only] = statuses;
  if (only && statuses.length === 1) return REQUEST_STATUS_CONFIG[only].label;
  return PART_ORDER.map((status) => ({ status, count: countOf(statuses, status) }))
    .filter(({ count }) => count > 0)
    .map(({ status, count }) => `${count} ${REQUEST_STATUS_CONFIG[status].label}`)
    .join(', ');
}

export function buildReferenceSummary(statuses: VerificationRequestStatus[]): string | null {
  if (statuses.length === 0) return null;
  if (countOf(statuses, 'CONFIRMED') === statuses.length) {
    return `Verified by ${contactsLabel(statuses.length)}`;
  }
  return `${contactsLabel(statuses.length)} · ${detail(statuses)}`;
}
